// Real photos of Filip Vimpel's BMW E46 drift car (uploaded by client)
const A = "https://customer-assets.emergentagent.com/job_ffea0a8b-865e-4b4a-9e43-8c5eb31150a1/artifacts";

export const PHOTOS = {
  wheelPaddock: `${A}/fafybioj__LSZ0758.webp`, // low-angle paddock, wheel + acid caliper, hood open
  redbullArch: `${A}/v7620zws__LSZ1924.webp`, // two cars under Red Bull arch
  smokeBarrier: `${A}/wz6k7w6m__LSZ2125-2.webp`, // drift, massive smoke, crowd
  motionBlur: `${A}/qdfuomc1__LSZ3798.webp`, // motion-blur side shot at speed
  paddockTent: `${A}/26375aw5__LSZ8326.webp`, // paddock tent, side profile — workshop vibe
};

export const HERO_VIDEO = "/drift-hero.mp4";

export const GALLERY = [
  {
    src: PHOTOS.motionBlur,
    title: "Plná rychlost",
    caption: "E46 v plném driftu — Race the Streets",
  },
  {
    src: PHOTOS.smokeBarrier,
    title: "Smoke show",
    caption: "Kouřová clona u bariéry, palec od betonu",
  },
  {
    src: PHOTOS.redbullArch,
    title: "Startovní brána",
    caption: "Tandemy pod Red Bull obloukem",
  },
  {
    src: PHOTOS.wheelPaddock,
    title: "Detail setupu",
    caption: "BBS kola, acid green třmeny, závodní příprava",
  },
  {
    src: PHOTOS.paddockTent,
    title: "Paddock life",
    caption: "Mezi jízdami — kapota nahoře, servis jede",
  },
];
